import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import PropTypes from 'prop-types'

const queryClient = new QueryClient()

export default function ContextProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}

ContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
}
